// Cross-component trigger for "open this specialist's full-response dialog".
// A citation link in the synthesized answer lives in a different part of the
// message tree than the specialist's own AgentToolCard (which owns the
// Dialog, since only it has the tool-call part context MessagePartPrimitive
// needs). This store is the signal between the two: the link requests a
// toolCallId, the matching card watches for it and opens, then clears the
// request so re-opening the same citation later still fires.

import { create } from 'zustand';

interface SpecialistDialogState {
  requestedToolCallId: string | null;
  request: (toolCallId: string) => void;
  clear: () => void;
}

export const useSpecialistDialogStore = create<SpecialistDialogState>((set) => ({
  requestedToolCallId: null,
  request: (toolCallId) => set({ requestedToolCallId: toolCallId }),
  clear: () => set({ requestedToolCallId: null }),
}));
